import React from 'react';
import Annotation from 'views/Annotation';

function AnnotationLayout() {
  return <Annotation />;
}

export default AnnotationLayout;
